const STORAGE_KEY = 'analytics:signup-page';
// The sign-up and onboarding screens say nothing about what the visitor came for.
const SIGNUP_FLOW_PATH = /^\/(sign-up|onboarding)(\/|$)/;

export function rememberPage(pathname: string): void {
  if (SIGNUP_FLOW_PATH.test(pathname)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, pathname);
  } catch {
    // Storage blocked: signupPage() falls back to the current path.
  }
}

// Session storage, so the page survives the full load into /sign-up and the reload after an OAuth sign-up.
export function signupPage(): string {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? window.location.pathname;
  } catch {
    return window.location.pathname;
  }
}
